import { render } from "./App.vue?vue&type=template&id=07b30fbe&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=07b30fbe&lang=scss"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__